//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import "./TwoD.less";
import ToneModel from "../myComponents/ToneModel/ToneModel.vue"
import ChatInput from '../myComponents/ChatInput/ChatInput.vue';
import S51WebGLSDK from "../S51WebGLSDK";
import { chatServiceStart, chatWordToVoice } from "../api/api";
import Chatframe from "../myComponents/Chatframe/Chatframe.vue";
import { CHAT_ROLE, CHAT_TYPE } from "../myComponents/Chatframe";
import { CHAT_EVNET, CHAT_MSG_TYPE } from "../S51WebGLSDK/define";
import AwaitReplyModel from "../myComponents/awaitReplyModel/awaitReplyModel.vue"
import CharacterInsufficient from "../myComponents/characterInsufficient/characterInsufficient.vue"
import PageVisible from "../myComponents/PageVisible/PageVisible.vue"
import EditTextModal from "../myComponents/EditTextModal/EditTextModal.vue"
import { modelView,cardView} from '../api/api';
import {
  getVuxUrlQuery,
  createRequest,
  makeBase64,
  getUrlParams,
} from "../utils/utils";
import {
  utils
} from '../S51WebGLSDK/utils/utils';
import { STORAGE_KEY } from "../utils/define";
import PaymentModel from "../myComponents/PaymentModel/PaymentModel.vue";
export default {
  name: "TwoD",
  components: {
    ChatInput,
    Chatframe,
    AwaitReplyModel,
    PaymentModel,
    PageVisible,
    CharacterInsufficient,
    EditTextModal,
    ToneModel
},
  props: {},
  data() {
    return {
      videoUrl: "",
      voiceContentList: [
        // {
        //   type:1, //1文字 2语音 3图片 4文件 5超链接
        //   name:'zgq', //内容
        //   differentiate:1, //1机器人 2用户
        //   id:1,
        //   imageUrl:'', //图片路径
        //   voiceUrl:'', //语音路径
        //   fileUrl:'', //文件下载地址
        //   linkUrl:'', //超链接地址
        //   videoUrl
        //   speed:,//文字显示速度 毫秒/字
        // },
      ],
      isLoading:false,
      packUnfoldState: true,
      clothingShow: false,
      clothingWhetherSelect: false,
      debugInfo: {
        modelID: 1,
        errorMessage: "",
        appID:"",
      },
      modelViewId:0,
      curAppID:'',
      imageType:2,
      awaitReply:false,
      height:0,
      isMyself:false,
      isChatGPT:false,
      packUnfoldBlo:false,
      preinstallList: [],
      purchaseModelIsopen:false,
      isHasConsume:false,
      ImageUrl:'',        //图片url
      playVideoSate:false,   //点击图片切换video的状态
      imageLoadState:false,  //图片是否加载完成的状态
      robberPurchase:false,
      editStateIsOpen:false,
      textareaValue:"",
      firmId:0, // 企业id
      defaultHeight: '0',  //默认屏幕高度
            nowHeight:  '0',  //实时屏幕高度
            upspringState:false
    };
  },
  computed: {},
  watch: {
    voiceContentList(value) {

      console.log('%c⧭', 'color: #514080', value)
      let getlos = localStorage.getItem("packUnfoldBlo_two");
      if (getlos == null || getlos == undefined || getlos == "") {
        localStorage.setItem("packUnfoldBlo_two", true);
        this.packUnfoldBlo = true;
      }
      if(this.packUnfoldState){
        this.clothingShow=false
      }

      console.log("%c⧭", "color: #e57373", value);
    },
    nowHeight() {
        if(this.defaultHeight!= this.nowHeight){
         //键盘弹出操作
         this.upspringState = true
        }else{
         //键盘不弹出操作
         this.upspringState = false
        }
    }
  },
  mounted() {
    //获取默认高度
    this.defaultHeight = document.documentElement.clientHeight;
    window.onresize = () => {
        return (() => {
           //实时屏幕高度
           this.nowHeight =document.documentElement.clientHeight;
        })();
    };
    this.height = document.documentElement.clientHeight - 485
    console.log('%c⧭', 'color: #f200e2', this.height)
    let param = utils.getUrlParams(window.location.href)
    this.modelViewId = Number(param.id)
    this.initSpareInfo()
  },
  destroyed() {},
  created() {
    localStorage.removeItem("packUnfoldBlo_two");
  },
  methods: {
    //模型设置成功
    onPatternSetFinish(e)
    {
      this.isChatGPT = e;
    },
    //通知修改文案modal起
    informEditModal(e)
    {
      this.editStateIsOpen = e.open;
      this.textareaValue=e.text;
    },
    onFreeOfCharge(e)
    {
      this.robberPurchase = e;
    },
    onCloseEditModal()
    {
       this.editStateIsOpen = false;
    },
    onSaveEditTextModal(e)
    {
       createRequest(
          "post",
          "applet/webview/card/setting",
          {
            card_id:this.modelViewId,
            greet:e,
          },
          (res) => {
            console.log("%c⧭", "color: #d90000", res.data);
            if (res.code == 200) {
              this.$vux.toast.show({
                type: "text",
                text: "保存成功",
              });
               this.editStateIsOpen = false;
               this.$refs.myChatFrame.updateHelloWord(e)
            } else {
              console.error(res.msg);
              this.$vux.toast.show({
                type: "text",
                text: res.msg,
              });
            }
          }
        )
    },
    onCharge(e)
    {
      this.robberPurchase = false;
      this.purchaseModelIsopen=true;
      this.awaitReply=false;
    },
    onChatLeftNotEnough(){
      if(this.isMyself){
        this.awaitReply=false;
        this.robberPurchase = true;
      }
    },
    //监听图片是否加载完成
    onImageLoad()
    {
      this.imageLoadState = true;
    },
    //播放视频
    onPlayVideo()
    {
      this.playVideoSate = true;
      this.$refs.video_play.play()
    },
     sendPreQuestion(question){
      console.log('发送预设问题:',question)
      // this.sendWord2Human(question.question)
      //测试阶段，返回固定应答
      if(this.isLoading){
        return
      }
      this.awaitReply=true
      this.$refs.myChatFrame.chat(CHAT_TYPE.TEXT,question.question,this.cardID).then(
        d=>{
          if(this.isChatGPT) this.isHasConsume=true
        },
        err=>{this.debugInfo.errorMessage=err}
      ).finally(()=>{
        this.awaitReply=false
      })
    },
    initSpareInfo() {
      this.$vux.loading.show({
        text: '载入中...',
        position:'absolute'
      })
      cardView(this.modelViewId).then((res) => {
        this.preinstallList = res.data.qa_list.data;
        this.curAppID = res.data.app_info.app_id;
        this.firmId = res.data.card.company_id
        chatServiceStart(res.data.app_info.app_id).then(prce=>{})
        this.videoUrl = res.data.card.generate_video;
        this.ImageUrl = res.data.card.generate_cover
        console.log('%c⧭', 'color: #73998c', res.data.card.generate_video)
        this.cardID = res.data.card.id
        document.title=res.data.card.name +'的名片'
        this.isMyself = res.data.card.uid == res.data.uid
        this.isChatGPT=res.data.card.chat_type==2
        if(res.data.card.greet && res.data.card.greet.length>0){
          chatWordToVoice(res.data.card.greet,this.curAppID).then((voiceRes) => {
            if (res.code == 200) {
                this.sayHello(res.data.card.greet,voiceRes.data.audio,null,null, voiceRes.data.duration)
            }
          }).finally(()=>{
            this.$vux.loading.hide()
          })

        }
        else{
          this.$vux.loading.hide()
        }
        localStorage.setItem(STORAGE_KEY.MODEL_NAME,res.data.card.name)
      },e=>{
        this.$vux.loading.hide()
      });
    },
    onChatListChange(value){
      this.voiceContentList=value
    },
    sayHello(helloWord,helloAudio,helloVisem,action,duration){
      this.$refs.myChatFrame.sayHello(helloWord,helloAudio,helloVisem,action,duration,this.isMyself)

    },
    onInputWordSend(message){
      console.log('send message',message)
      if(this.isLoading){
        return
      }
      if (!message || message.length == 0) {
        return;
      }
      this.sendWord2Human(message)
    },
    onInputStartRecordAudio(){
      console.log('开始录音')
      S51WebGLSDK.stopNowVoice();
    },
    onInputEndRecordAudio(data){
      console.log('结束录音',data)
      this.awaitReply=true
      this.$refs.myChatFrame.chat(CHAT_TYPE.VOICE,data,this.cardID).then(
        ()=>{
          if(this.isChatGPT)  this.isHasConsume=true
        },//成功
        (err)=>{ this.debugInfo.errorMessage = err;}
      ).finally(()=>{this.awaitReply=false})
   
    },
    sendWord2Human(myChatMessage){
      this.awaitReply=true
      this.$refs.myChatFrame.chat(CHAT_TYPE.TEXT,myChatMessage,this.cardID).then(
        ()=>{
          if(this.isChatGPT)  this.isHasConsume=true
        },//成功
        (err)=>{ this.debugInfo.errorMessage = err;}
      ).finally(()=>{this.awaitReply=false})
    },
  
    onUpChat(){
      if (this.isLoading) {
        return;
      }
      // this.switchPage(e)
      this.$router.push({path:'/setQaPage',query:{id:this.modelViewId,token:localStorage.getItem(STORAGE_KEY.TOKEN),type:'2d'}});
    },
    informImmediatelyPurchase(e){
      if(e){//充值成功
        this.purchaseModelIsopen=false
        this.$vux.toast.show({
            type: "text",
            text: "充值成功",
        })
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/TwoD.vue